import styled, { keyframes } from 'styled-components'

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  40% {
    transform: translateX(-50%) translateY(-10px);
  }
  60% {
    transform: translateX(-50%) translateY(-5px);
  }
`

export const Container = styled.div`
  margin-bottom: 40px;
`
export const Wrapper = styled.div`
  border-radius: 10px;
  padding: 15px 5px 15px 15px;
  border: 1px solid ${props => (props.termsRead ? props.theme.colors.border : props.theme.colors.alertColor)};
  position: relative;
`

export const Terms = styled.div`
  width: 100%; // Adjust as needed
  height: 140px; // Adjust as needed
  overflow-y: auto;
  box-sizing: border-box; // Ensures padding is included in the element's dimensions

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a0a0a0;
  }
`

export const TermsLabel = styled.div`
  color: ${props => props.theme.colors.lightText};
  font-size: 1.2rem;
  margin-bottom: 10px;
  white-space: nowrap;
  margin-top: 25px;
`

export const Label = styled.div``

export const Text = styled.p`
  margin-right: 10px;
  white-space-collapse: preserve;
`

export const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.95);
  padding: 8px 16px;
  border-radius: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  animation: ${bounce} 2s infinite;
  z-index: 10;
  border: 1px solid ${props => props.theme.colors.border};
  width: max-content;
  max-width: 90%;
`

export const ScrollText = styled.span`
  font-size: 0.85rem;
  color: ${props => props.theme.colors.text};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
`

export const ScrollIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
`
